import { isPsP } from '../enums/business-model.enum'

export const BALANCE_ACTIONS_ENUM = {
  view: 'recipients.balance:view'
}

export const SETTLEMENTS_ACTIONS_ENUM = {
  view: 'recipients.settlements:view'
}

const recipientsBalanceEnabled = (
  permissionIsEnabledFn,
  componentIsEnabledFn,
  businessModel
) => {
  return (
    componentIsEnabledFn('recipients', 'balance') &&
    permissionIsEnabledFn(BALANCE_ACTIONS_ENUM.view) &&
    isPsP(businessModel)
  )
}

const recipientsSettlementsEnabled = (
  permissionIsEnabledFn,
  componentIsEnabledFn
) => {
  return (
    componentIsEnabledFn('recipients', 'settlements') &&
    permissionIsEnabledFn(SETTLEMENTS_ACTIONS_ENUM.view)
  )
}

export { recipientsBalanceEnabled, recipientsSettlementsEnabled }
